'use strict';

/**
 * Инциализация mcustomscrollbar
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector]- поиск элементов по селектору
 * @sourceCode
 */
function mCustomScroll (selector) {
	$(selector).mCustomScrollbar();
}

(function () {
	if (!window.Modernizr.cssscrollbar && !window.Modernizr.touchevents) {
		require.ensure([], () => {
			require('jquery-mousewheel');
			require('malihu-custom-scrollbar-plugin');
			require('_vendors/jquery.mCustomScrollbar.css');
			mCustomScroll('.js-customscroll');
		}, 'mcustomscrollbar');
	}
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/mcusmoscrollbar.js